/** Active visible time in this page session. No confidence/learning inference. */
export class ResponseClock {
  private elapsed = new Map<string, number>();
  private active: { key: string; at: number } | null = null;
  constructor(private readonly now: () => number) {}
  show(key: string): void {
    if (this.active?.key === key) return;
    this.pause();
    if (!this.elapsed.has(key)) this.elapsed.set(key, 0);
    this.active = { key, at: this.now() };
  }
  pause(): void {
    if (this.active === null) return;
    const { key, at } = this.active;
    this.elapsed.set(key, (this.elapsed.get(key) ?? 0) + Math.max(0, this.now() - at));
    this.active = null;
  }
  finish(key: string): number | null {
    this.pause();
    const ms = this.elapsed.get(key);
    return ms === undefined || !Number.isFinite(ms) || ms > 86_400_000 ? null : Math.round(ms);
  }
  clear(): void { this.active = null; this.elapsed.clear(); }
}
